import { createAction, props } from '@ngrx/store';

export const campaingSelected = createAction('[Header Component] CampaingSelected', props<{ campaing: string }>())
